import React from 'react';

const DeletePopUp = ({deleteRequestedProduct, handleDeletePopUP, handleDelete}) => {
    return (
        
        <React.Fragment>
          <div
            className='delete-popup-background'
            onClick={handleDeletePopUP}
          ></div>
          <div className='delete-pop-up'>
            <h5>Are you sure to delete this product?</h5>
            <div className='inner-pop'>
              <img src={deleteRequestedProduct.imageUrl} alt='pop' />
              <div className='inner-pop-text'>
                <h2>Name: {deleteRequestedProduct.label}</h2>
                <h2>Size: {deleteRequestedProduct.size}</h2>
              </div>
            </div>
            <button
              onClick={() => handleDelete(deleteRequestedProduct)}
            >
              Yes
            </button>
            <button onClick={handleDeletePopUP}>No</button>
          </div>
        </React.Fragment>
      );
}
 
export default DeletePopUp;